import { render } from "./AuError.vue?vue&type=template&id=4c40e376&scoped=true"
import script from "./AuError.vue?vue&type=script&lang=js"
export * from "./AuError.vue?vue&type=script&lang=js"

import "./AuError.vue?vue&type=style&index=0&id=4c40e376&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c40e376"]])

export default __exports__